import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productionKey: {
    description: 'API Key title',
    defaultMessage: 'Production Key',
    id: '4a65Ct',
  },
  generatingApiKey: {
    description: 'Button title',
    defaultMessage: 'Generating API Key',
    id: 'G4w5fp',
  },
  generateApiKey: {
    description: 'Button title',
    defaultMessage: 'Generate API Key',
    id: 'j222mJ',
  },
});
